import * as React from 'react';
import s from '../InvoicePay.scss';
import { WithTranslation, withTranslation } from 'react-i18next';
import { Button } from '@wix/design-system';
import ArrowLeft from 'wix-ui-icons-common/ArrowLeft';

export interface HeaderProps extends WithTranslation {
  backUrl: string;
}

const InvoicePayHeaderComp: React.FunctionComponent<HeaderProps> = ({
  t,
  backUrl,
}) => {
  return (
    <div className={`${s.header} ${s.hideMobile}`}>
      <div className={s.buttons}>
        <Button
          className={s.backButton}
          as="a"
          href={backUrl}
          dataHook="back-button"
          priority="secondary"
          prefixIcon={<ArrowLeft height="12" />}
        >
          <span data-hook="back-button-label">
            {t('quoteview.back_to_invoice')}
          </span>
        </Button>
      </div>
    </div>
  );
};
export const InvoicePayHeader = withTranslation()(InvoicePayHeaderComp);
